/**
 * @param {string} value
 * @returns {string|undefined}
 */
function lowercaseFirstLetter (value) {
  if (!value || typeof value !== 'string') return ''

  const firstChar = value
    ?.toString()
    ?.charAt(0)
    ?.toLowerCase()

  const rest = value
    ?.toString()
    ?.substr(1)

  return `${firstChar}${rest}`
}

module.exports = { lowercaseFirstLetter }
